import React, { useState } from "react";
import { DividerDropdowns, Href, Wishlist } from "../../../../Constant";
import { Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { DIVIDER_DATA, DIVIDER_SPORT_DATA } from "../../../../Data/UiKit/Dropdown";
import CommonDropDown from "../Common/CommonDropDown";

const DividerDropdown = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={DividerDropdowns} span={DIVIDER_DATA} />
        <CardBody className="rtl-dropdown">
          <div className="common-flex">
            <div className="btn-group">
              <Dropdown isOpen={open} toggle={toggle}>
                <DropdownToggle caret color="success" className="rounded-pill text-white">{Wishlist}</DropdownToggle>
                <DropdownMenu className="dropdown-block">
                  <DropdownItem htef={Href}>Shoes</DropdownItem>
                  <DropdownItem htef={Href}>Bag</DropdownItem>
                  <DropdownItem htef={Href}>Clothes</DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem htef={Href}>Separated link</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            {DIVIDER_SPORT_DATA.map((data, index) => (
              <CommonDropDown key={index} item={data} />
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default DividerDropdown;
